import React, { Fragment } from 'react';
import { useTranslate } from '@bynder/localization';
import { colorParams2Color } from '~/common/editor/editorHelper';
import { useElementStyleModal } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextStyles/modals/useElementStyleModal';
import { FullWidthFlex } from './Component.styled';
import { SidebarSection } from '../../../../FormComponents/EditorColor/EditorColor.styled';
import ColorSearch from '../../../../FormComponents/EditorColor/components/ColorSearch';
import ColorPicker from '../../../../FormComponents/ColorPicker';
import ColorDropdown from '../../../../FormComponents/EditorColor/components/ColorsDropdown';
import ColorDetach from '../../../../FormComponents/EditorColor/components/ColorDetachDropdown';
import useFontColorManipulator from './useFontColorManipulator';

type Props = {
    creativeModel: any;
    selectedElement: any;
    disabled: boolean;
};

export const FontColorManipulator = ({ creativeModel, selectedElement, disabled }: Props) => {
    const {
        hasBrandColors,
        isMixed,
        isAlphaMixed,
        onChange,
        colors,
        palettes,
        brandColors,
        customColors,
        onAppliedClick,
        setBrandColor,
        onColorDetach,
        elementColors,
    } = useFontColorManipulator({ creativeModel, selectedElement });
    const { openElementColorStylesModal, renderElementStyleModal } = useElementStyleModal({
        creativeModel,
        selectedElement,
    });
    const { translate } = useTranslate();

    const Wrapper = !hasBrandColors ? SidebarSection : Fragment;

    return (
        <FullWidthFlex justifyContent="space-between" alignItems="center">
            <Wrapper>
                {!hasBrandColors && (
                    <ColorPicker
                        id={selectedElement?.id}
                        testId="shots-text-font-color"
                        label={translate('editor.sidebar.shots.colorpicker.label')}
                        value={colorParams2Color(colors[0])}
                        isMixed={isMixed}
                        isAlphaMixed={isAlphaMixed}
                        handleOnChange={onChange}
                        disabled={disabled}
                    />
                )}
                <ColorDropdown
                    testId="shots-text-font-color"
                    colors={colors}
                    palettes={palettes}
                    selectedBrandColors={brandColors}
                    disabled={disabled}
                >
                    <ColorSearch
                        elementColors={elementColors}
                        onAppliedClick={onAppliedClick}
                        selectedBrandColors={brandColors}
                        selectedCustomColors={customColors}
                        setBrandColor={setBrandColor}
                        palettes={palettes}
                        openElementStylesModal={openElementColorStylesModal}
                        testId="shots_text_font_color"
                    />
                </ColorDropdown>
                {hasBrandColors && (
                    <ColorDetach
                        hasMultipleColors={isMixed}
                        testId="shots-text-font-color"
                        onColorDetach={onColorDetach}
                        disabled={disabled}
                    />
                )}
            </Wrapper>
            {renderElementStyleModal()}
        </FullWidthFlex>
    );
};

export default FontColorManipulator;
